const Card = ({ children, ...props }) => {
    return(
        <div {...props} className='flex flex-col px-4 py-2 bg-primarioMira shadow-2xl rounded-2xl lg:rounded-none lg:rounded-r-2xl lg:basis-1/3'>
            {children}
        </div>
    )
}

export default Card